import { useRecoilState, useSetRecoilState } from 'recoil';
import { useStepValidation } from '@zurich/common/contexts';
import { Drawer } from '@zurich/ui/atoms';
import { styled } from '@zurich/ui/legacy/utils';
import type { StepNames } from '~/lib/types';
import {
  damagesFieldSelector,
  editDamageId,
  showDamageContentAtom,
} from '~/state';
import { DocumentDamageAllPhotos } from './DocumentDamageAllPhotos';
import { DocumentDamageDataEntry } from './DocumentDamageDataEntry';

type DocumentDamageDrawerProps = {
  toggleDrawer: (toggle: boolean) => () => void;
  open: boolean;
  stepName: StepNames;
};

export function DocumentDamageDrawer({
  toggleDrawer,
  open,
  stepName,
}: DocumentDamageDrawerProps) {
  const [showDamageContent, setShowDamageContent] = useRecoilState(
    showDamageContentAtom
  );
  const setDamages = useSetRecoilState(damagesFieldSelector);
  const [editDamageIdValue, setEditDamageIdValue] =
    useRecoilState(editDamageId);
  const { resetStepValidation } = useStepValidation();

  function handleShowDamageContent() {
    setShowDamageContent(!showDamageContent);
  }

  const resetImageBlob = (id: string | undefined) => {
    if (!id) {
      return;
    }

    if (editDamageIdValue) {
      setEditDamageIdValue(undefined);
      return;
    }

    setDamages((prev) => prev.filter((damage) => damage.id !== id));
    resetStepValidation();
  };

  return (
    <Drawer open={open} anchor="right">
      <BoxStyled role="presentation">
        {showDamageContent && (
          <DocumentDamageDataEntry
            resetImageBlob={resetImageBlob}
            handleShowDamageContent={handleShowDamageContent}
            stepName={stepName}
          />
        )}
        {!showDamageContent && (
          <DocumentDamageAllPhotos
            toggleDrawer={toggleDrawer}
            handleShowDamageContent={handleShowDamageContent}
            stepName={stepName}
          />
        )}
      </BoxStyled>
    </Drawer>
  );
}

const BoxStyled = styled('div')(({ theme }) => ({
  width: '100vw',
  padding: '0 24px',
  height: '100vh',
  marginBottom: theme.spacing(3),
}));
